// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiRequestBase {
    static getAttributeTypeMap() {
        return PharmacyBiRequestBase.attributeTypeMap;
    }
}
PharmacyBiRequestBase.discriminator = undefined;
PharmacyBiRequestBase.additionalProperties = false;
PharmacyBiRequestBase.attributeTypeMap = [
    {
        "name": "diagnosis",
        "baseName": "diagnosis",
        "type": "PharmacyBiDiagnosis"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "PharmacyBiPatient"
    },
    {
        "name": "payor",
        "baseName": "payor",
        "type": "PharmacyBiPayor"
    },
    {
        "name": "practice",
        "baseName": "practice",
        "type": "PharmacyBiPractice"
    },
    {
        "name": "prescriber",
        "baseName": "prescriber",
        "type": "PharmacyBiPrescriber"
    },
    {
        "name": "prescription",
        "baseName": "prescription",
        "type": "PharmacyBiPrescription"
    },
    {
        "name": "specialtyPharmacy",
        "baseName": "specialtyPharmacy",
        "type": "PharmacyBiSpecialtyPharmacy"
    },
    {
        "name": "pharmacyNPI",
        "baseName": "pharmacyNPI",
        "type": "string"
    },
    {
        "name": "programId",
        "baseName": "programId",
        "type": "string"
    },
    {
        "name": "providerProgramId",
        "baseName": "providerProgramId",
        "type": "string"
    },
    {
        "name": "clientId1",
        "baseName": "clientId1",
        "type": "string"
    },
    {
        "name": "clientId2",
        "baseName": "clientId2",
        "type": "string"
    },
    {
        "name": "clientId3",
        "baseName": "clientId3",
        "type": "string"
    },
    {
        "name": "clientId4",
        "baseName": "clientId4",
        "type": "string"
    },
    {
        "name": "clientId5",
        "baseName": "clientId5",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiRequestBase.js.map